"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigPopupType = void 0;
var BigPopupType;
(function (BigPopupType) {
    BigPopupType[BigPopupType["SUCCESS"] = 0] = "SUCCESS";
    BigPopupType[BigPopupType["FAILED"] = 1] = "FAILED";
    BigPopupType[BigPopupType["QUESTION"] = 2] = "QUESTION";
    BigPopupType[BigPopupType["CALLPOPUP"] = 3] = "CALLPOPUP";
})(BigPopupType = exports.BigPopupType || (exports.BigPopupType = {}));
